// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import {
  wrapFormComponentWithLabelAndError,
  wrapFormComponentWithError,
} from './StyledFormComponentWrappers';
import connectFormComponentToReduxForm from 'utils/connectFormComponentToReduxForm';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

const currentYear = new Date().getFullYear();
const dobPipe = createAutoCorrectedDatePipe('mm/dd/yyyy', {
  minYear: 1900,
  maxYear: currentYear + 1,
});
const calendarSelectionPipe = createAutoCorrectedDatePipe('mm/dd/yyyy', {
  minYear: 2010,
  maxYear: 2099,
});

const RawDateMaskInput = ({ name, mask, ...otherInputProps }) => (
  <MaskedInput
    name={name}
    id={name}
    type="text"
    className="input-large"
    placeholder="mm/dd/yyyy"
    mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
    pipe={mask === 'dob' ? dobPipe : calendarSelectionPipe}
    {...otherInputProps}
  />
);

RawDateMaskInput.propTypes = {
  mask: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

RawDateMaskInput.defaultProps = {
  mask: 'calendarSelection', // TODO: Create a more sensible default, be sure to make use of calendarSelection explicit
};

RawDateMaskInput.displayName = 'RawDateMaskInput';

export { RawDateMaskInput };

const DateMaskInput = connectFormComponentToReduxForm(wrapFormComponentWithError(RawDateMaskInput));

DateMaskInput.displayName = 'DateMaskInput';

export { DateMaskInput };

const RawDateMaskField = wrapFormComponentWithLabelAndError(RawDateMaskInput);
RawDateMaskField.displayName = 'RawDateMaskField';

export { RawDateMaskField };

const DateMaskField = connectFormComponentToReduxForm(RawDateMaskField);
DateMaskField.displayName = 'DateMaskField';

export default DateMaskField;
